import React from 'react'
import PropTypes from 'prop-types'
import CountdownProvider from '../../../util/providers/CountdownProvider'
import { SplitLoginEmailPinCodeCheckTemplate } from '../../templates/SplitLoginEmailPinCodeCheckTemplate'

export const SplitLoginEmailPinCodeCheckPage = ({
  email,
  onSuccess,
  onBackClick,
  onChallengePinCodeCall,
  abTests = '',
  onPhoneNotValidatedError,
  sessionTokens,
  onAccountNotValidated,
  onAccountMustValidate,
  modalMode,
  onAccountCompleteData,
}) => (
  <CountdownProvider>
    <SplitLoginEmailPinCodeCheckTemplate
      email={email}
      onSuccess={onSuccess}
      onBackClick={onBackClick}
      onChallengePinCodeCall={onChallengePinCodeCall}
      abTests={abTests}
      onPhoneNotValidatedError={onPhoneNotValidatedError}
      sessionTokens={sessionTokens}
      onAccountNotValidated={onAccountNotValidated}
      onAccountMustValidate={onAccountMustValidate}
      modalMode={modalMode}
      onAccountCompleteData={onAccountCompleteData}
    />
  </CountdownProvider>
)

SplitLoginEmailPinCodeCheckPage.propTypes = {
  email: PropTypes.string.isRequired,
  abTests: PropTypes.string,
  onSuccess: PropTypes.func.isRequired,
  onSwitchMethod: PropTypes.func,
  onChallengePinCodeCall: PropTypes.func,
  sessionTokens: PropTypes.object,
  onAccountNotValidated: PropTypes.func,
  modalMode: PropTypes.bool,
  onAccountCompleteData: PropTypes.func,
}
